export default __webpack_public_path__ + "static/media/global_icon.3beeb5b0.png";